import downloadAgendasSaga from './downloadAgendasSaga'
import sendAgendasSaga from './sendAgendasSaga'
import sendTestAgendasSaga from './sendTestAgendas'
import eventReportSaga from './eventReportSaga'
import linkedinEnrichSaga from './linkedinEnrich'
import scrapeReportSaga from './scrapeReportSaga'
import auditTrailReportSaga from './auditTrailReport'

const reportingSagas = [
    downloadAgendasSaga(),
    sendAgendasSaga(),
    eventReportSaga(),
    sendTestAgendasSaga(),
    linkedinEnrichSaga(),
    scrapeReportSaga(),
    auditTrailReportSaga()
]

export default reportingSagas
